<template>
  <li>
    <p>{{ skill.name }}</p>
    <v-text-field
      :label="$t('components.formLikert.fields.skills.weight.name')"
      v-model="skill.weight"
      type="number"
      :min="1"
      :max="5"
      :step="1"
      :error-messages="weightErrors"
    />
    <v-btn class="app__btn__delete"
           height="35"
           min-width="35"
           color="cancel"
           small
           @click="$emit('remove-skill', skill.id)"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </li>
</template>

<script>
import { required, between, integer } from 'vuelidate/lib/validators'

export default {
  name: 'LikertSkillItem',
  props: {
    skillInit: {
      required: true,
      type: Object
    },
    getValidate: {
      required: true,
      type: Boolean
    }
  },
  data: () => {
    return {
      skill: {}
    }
  },
  computed: {
    weightErrors () {
      const errors = []
      if (!this.$v.skill.$dirty) return errors
      if (!this.$v.skill.weight.required) errors.push('La pondération doit être renseignée.')
      if (!this.$v.skill.weight.between) {
        let minWeight = this.$v.skill.weight.$params.between.min
        let maxWeight = this.$v.skill.weight.$params.between.max
        errors.push(`La pondération doit être comprise entre ${minWeight} et ${maxWeight}.`)
      }
      if (!this.$v.skill.weight.integer) errors.push('La pondération doit être un entier.')
      return errors
    }
  },
  watch: {
    getValidate: function () {
      this.$v.$touch()
    }
  },
  validations: {
    skill: {
      weight: {
        required,
        between: between(1, 5),
        integer
      }
    }
  },
  beforeMount () {
    this.skill = this.skillInit
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppButtonErnest";

  li {
    display: grid;
    grid-template-columns: 5fr 1fr 80px;
    align-items: center;
    margin-left: 20px;
  }
</style>
